import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=6d0cc2b2&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=6d0cc2b2&prod&scoped=true&lang=css&"
import style1 from "./notes.vue?vue&type=style&index=1&id=6d0cc2b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cc2b2",
  null
  
)

export default component.exports